import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './components/Home/Home';
import { createContext, useState } from 'react';
import Projects from './components/Projects/Projects';
import Admin from './components/Admin/Admin';
import Login from './components/Login/Login';
import Resume from './components/Resume/Resume';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
export const UserContext = createContext();

function App() {
  const [cardDisplay, setCardDisplay] = useState(0);
  const [authentication, setAuthentication] = useState(false);
  const [snackBarUI, setSnackBarUI] = useState({ state: false, severity: '', message: '' })
  const [backdropUI, setBackdropUI] = useState(false);

  return (
    <UserContext.Provider value={
      [
        cardDisplay, setCardDisplay,
        authentication, setAuthentication,
        snackBarUI, setSnackBarUI,
        backdropUI, setBackdropUI
      ]
    }>
      <Router>
        <ScrollToTop />
        <Switch>

          <Route path="/projects">
            <Projects />
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <PrivateRoute path="/admin">
            <Admin />
          </PrivateRoute>

          <Route path="/resume">
            <Resume />
          </Route>

          <Route exact path="/">
            <Home />
          </Route>

          <Route path="*">
            <Home />
          </Route>

        </Switch>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
